import React from 'react';
import clsx from 'clsx';
import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles<Theme>(({ palette }) => ({
  root: {
    background: palette.background.default,
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  },
}));

interface Props {
  children: React.ReactNode;
  className?: string;
}

export function Page({ children, className }: Props): React.ReactElement {
  const classes = useStyles();

  return <div className={clsx(classes.root, className)}>{children}</div>;
}
